import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { isMobileLike } from '../lib/device';
import { Landing } from './Landing';
import { Banner } from '../components/Banner';

// Root route: if we detect a mobile/phone device, bounce to /app immediately.
// Otherwise show the desktop landing with QR. Users can still click through.
export function Index() {
  const navigate = useNavigate();
  useEffect(() => {
    if (isMobileLike()) {
      navigate('/app', { replace: true });
    }
  }, [navigate]);

  return (
    <>
      <Banner />
      <Landing />
    </>
  );
}
